/** Coerce API `null`, RHF partial rows, and other non-strings to safe display/form strings. */
export const toFormString = (value: unknown): string => {
  if (value == null) return "";
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  if (value instanceof Date) {
    return value.toISOString();
  }
  return "";
};

export const toFormBoolean = (value: unknown, fallback = false): boolean =>
  typeof value === "boolean" ? value : fallback;

export function hasNonEmptyTrimmedString(value: unknown): boolean {
  return toFormString(value).trim().length > 0;
}
